"use client";

import { useAtomValue } from "jotai";
import React, { type ReactElement } from "react";
import { ObservatoryCard } from "@/components";
import {
  filteredObservatoriesAtom,
  themeVisibilityAtom,
} from "@/store/devices";
import { ThemeTypeEnum } from "@/types";

function DevicesDeviceList(): ReactElement | null {
  const filteredObservatories = useAtomValue(filteredObservatoriesAtom);
  const themeVisibility = useAtomValue(themeVisibilityAtom);

  return (
    <section className="py-4 md:pl-4">
      <ul className="list-none grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        {filteredObservatories.map((observatory) => {
          const isVisible = themeVisibility[observatory.theme as ThemeTypeEnum];
          return isVisible ? (
            <li className="flex flex-col" key={observatory.id}>
              <ObservatoryCard observatory={observatory} />
            </li>
          ) : null;
        })}
      </ul>
    </section>
  );
}

export { DevicesDeviceList };
